import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsSettingsApiService {

  readonly analyticsConfigurationUrl: string = 'configuration/analytics';

  constructor(private http: HttpClient) {}

  public getAnalyticsConfiguration(): Observable<any> {
    return this.http.get(this.analyticsConfigurationUrl);
  }

  public updateAnalyticsConfiguration(configuration): Observable<any> {
    return this.http.put(this.analyticsConfigurationUrl, configuration);
  }
}
